import { Source, Layer } from '@vis.gl/react-maplibre';
import type { FlowTileStyle } from '../../types/traffic';

const TOMTOM_KEY = import.meta.env.VITE_TOMTOM_API_KEY as string | undefined;

interface TrafficLayerProps {
  flowStyle?: FlowTileStyle;
}

export function TrafficLayer({ flowStyle = 'relative0' }: TrafficLayerProps) {
  if (!TOMTOM_KEY) return null;

  return (
    <>
      <Source
        id="tomtom-traffic"
        type="raster"
        tiles={[
          `https://api.tomtom.com/traffic/map/4/tile/flow/${flowStyle}/{z}/{x}/{y}.png?key=${TOMTOM_KEY}&tileSize=512`
        ]}
        tileSize={256}
      >
        <Layer
          id="traffic-flow"
          type="raster"
          paint={{ 'raster-opacity': 0.8 }}
        />
      </Source>
      <Source
        id="tomtom-incidents"
        type="raster"
        tiles={[
          `https://api.tomtom.com/traffic/map/4/tile/incidents/s0-dark/{z}/{x}/{y}.png?key=${TOMTOM_KEY}&tileSize=512`
        ]}
        tileSize={256}
      >
        <Layer
          id="traffic-incidents"
          type="raster"
          paint={{ 'raster-opacity': 0.9 }}
        />
      </Source>
    </>
  );
}
